const penaltyPointsTypes = {
  SET_PENALTY_HISTORY: "SET_PENALTY_HISTORY",
};

export default penaltyPointsTypes;
